import {Component, OnInit} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {RouterLink} from '@angular/router';
import {TargetBlankDirective} from 'commons';


@Component({
    selector: 'myupdates-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    imports: [TargetBlankDirective, RouterLink, TranslatePipe]
})
export class FooterComponent implements OnInit {

  // intentionally empty
  ngOnInit(): void {} // NOSONAR

}
